class InterceptorRequestHandler {
    constructor(next, interceptor) {
        this.next = next;
        this.interceptor = interceptor;
    }
    handle(request) {
        return this.interceptor.intercept(request, this.next);
    }
}
/**
 * Compose a list of interceptors with a given CoralHandler to produce a chain
 * of interceptors which will each be called before the handler finally is
 * called to handle the request.
 */
export class InterceptingHandler {
    constructor(handler, interceptors) {
        this.handler = handler;
        this.handlerChain = interceptors.reduceRight((next, interceptor) => {
            return new InterceptorRequestHandler(next, interceptor);
        }, this.handler);
    }
    handle(request) {
        return this.handlerChain.handle(request);
    }
}
